import { useAuth } from '../auth/AuthContext';
import { config } from '../config';
import { DashboardCards } from '../features/reports/DashboardCards';
import { ModuleCards } from '../features/reports/ModuleCards';
import { SystemStatus } from '../features/system/SystemStatus';
import { t } from '../i18n';

export function DashboardPage() {
  const { user, can } = useAuth();
  return (
    <div className="mx-auto max-w-5xl space-y-6">
      <header>
        <h1 className="text-2xl font-bold">{t('dashboard.title')}</h1>
        <p className="mt-1 text-slate-600">
          {t('dashboard.welcome', { product: config.productName })}
        </p>
        {user && <p className="mt-1 text-sm">{t('dashboard.hello', { name: user.fullName })}</p>}
      </header>
      <DashboardCards />
      <ModuleCards />
      {/* Which services are up is for the people who run the system, not for every parent who signs in. */}
      {can('audit.view') && <SystemStatus />}
    </div>
  );
}
